export const ADMIN_APP_ASSET_PATHS = {
  boostLogo: 'assets/boost.png',
  play: 'assets/play.png',
  attentiveSpotlight: 'assets/attentive-spotlight.png',
  accountSettings: {
    turboBg2X: 'assets/account-settings/turbo-bg-2x.png',
    turboText: 'assets/account-settings/turbo-text.svg',
    upgradeTurboSuccess: 'assets/account-settings/upgrade-turbo-success.png'
  },
  advanceSearch: {
    aiSynonymsBanner: 'assets/advance-search/ai-synonyms-banner.png',
    generalBottomArrow: 'assets/advance-search/general-bottom-arrow.png',
    generalFinalResult: 'assets/advance-search/general-final-result.png',
    generalPersonalization: 'assets/advance-search/general-personalization.png',
    generalProductPerformanceRanking:
      'assets/advance-search/general-product-performance-ranking.png',
    generalResult: 'assets/advance-search/general-result.png',
    generalSemanticSearch: 'assets/advance-search/general-semantic-search.png',
    generalSynonyms: 'assets/advance-search/general-synonyms.png',
    generalTopArrow: 'assets/advance-search/general-top-arrow.png',
    gradientHorizontal: 'assets/advance-search/gradient-horizontal.png',
    gradientVertical: 'assets/advance-search/gradient-vertical.png',
    magnifyingGlass: 'assets/advance-search/magnifying-glass.png',
    personalizationBanner: 'assets/advance-search/personalization-banner.png',
    personalizationPresentBanner01: 'assets/advance-search/personalization-present-banner-01.png',
    personalizationPresentBanner02: 'assets/advance-search/personalization-present-banner-02.png',
    personalizationPresentBanner: 'assets/advance-search/personalization-present-banner.png',
    rankingBanner: 'assets/advance-search/ranking-banner.png',
    scopedSuggestionBanner: 'assets/advance-search/scoped-suggestion-banner.png',
    semanticBanner: 'assets/advance-search/semantic-banner.png'
  },
  abTesting: {
    guideBannerImg: 'assets/ab-testing/ab-testing-guide.png',
    lockImg: 'assets/ab-testing/ab-testing-lock-img.png'
  },
  banners: {
    aiPowerRecommendAddon: 'assets/banners/ai-power-recommend-addon.png',
    aiSynonymsGuide: 'assets/banners/ai-synonyms-guide.png',
    backgroundBannerCustom: 'assets/banners/background-banner-custom.png',
    inCollectionSearchGuide: 'assets/banners/in-collection-search-guide.png',
    instantSearchWidgetGuide: 'assets/banners/instant-search-widget-guide.png',
    manualSynonymsGuide: 'assets/banners/manual-synonyms-guide.png',
    merchandisingGuide: 'assets/banners/merchandising-guide.png',
    personalizationGuide: 'assets/banners/personalization-guide.png',
    preOrderCampaignGuide: 'assets/banners/pre-order-campaign-guide.png',
    preOrderSettingsGuide: 'assets/banners/pre-order-settings-guide.png',
    preOrderNotificationSettingsGuide: 'assets/banners/pre-order-notification-settings-guide.png',
    revenueToolsDomainSetting: 'assets/banners/revenue-tools-domain-setting.png',
    predictiveBundleGuide: 'assets/banners/predictive-bundle-guide.svg',
    productPerformanceRankingGuide: 'assets/banners/product-performance-ranking-guide.png',
    promoteCustomMerchandising: 'assets/banners/promote-custom-merchandising.png',
    recommendationWidgetGuide: 'assets/banners/recommendation-widget-guide.png',
    redirectsGuide: 'assets/banners/redirects-guide.png',
    relevanceSettingsGuide: 'assets/banners/relevance-settings-guide.png',
    requireUpgradeStandardSearch: 'assets/banners/require-upgrade-standard-search.png',
    searchPersonalizationAddToCartRate:
      'assets/banners/search-personalization-add-to-cart-rate.png',
    searchPersonalizationClickThroughRate:
      'assets/banners/search-personalization-click-through-rate.png',
    searchPersonalizationConversionRate:
      'assets/banners/search-personalization-conversion-rate.png',
    searchPersonalizationGuide: 'assets/banners/search-personalization-guide.png',
    searchResultsPageGuide: 'assets/banners/search-results-page-guide.png',
    semanticSearchGuide: 'assets/banners/semantic-search-guide.png',
    stopWordsGuide: 'assets/banners/stop-words-guide.png',
    subscriptionInfoBanner: 'assets/banners/subscription-info-banner.svg',
    suggestionDictionaryGuide: 'assets/banners/suggestion-dictionary-guide.png',
    syncInfoBanner: 'assets/banners/sync-info-banner.svg',
    syncSettingBanner: 'assets/banners/sync-setting-banner.svg',
    syncStatusBanner: 'assets/banners/sync-status-banner.svg',
    upgradeStandardSearch: 'assets/banners/upgrade-standard-search.png',
    variantsDisplayGuide: 'assets/banners/variants-display-guide.png',
    filterLayout: 'assets/banners/filter-layout-thumbnail.png',
    filterTrees: 'assets/banners/filter-trees-thumbnail.png',
    displaySettings: 'assets/banners/display-settings-thumbnail.png',
    mergeValues: 'assets/banners/merge-values-thumbnail.png',
    customRangeSlider: 'assets/banners/custom-range-slider-thumbnail.png',
    searchControl: 'assets/banners/search-control-thumbnail.png',
    otherSearch: 'assets/banners/other-search-thumbnail.png',
    commerceSearch: 'assets/banners/commerce-search-thumbnail.png',
    searchRules: 'assets/banners/search-rules-thumbnail.png',
    collectionRules: 'assets/banners/collection-rules-thumbnail.png',
    abTest: 'assets/banners/ab-test-thumbnail.png',
    recommendation: 'assets/banners/recommendation-thumbnail.png',
    predictiveBundle: 'assets/banners/predictive-bundle-thumbnail.png',
    backInStock: 'assets/banners/back-in-stock-thumbnail.png',
    preOrder: 'assets/banners/pre-order-thumbnail.png',
    domainSettings: 'assets/banners/domain-settings-thumbnail.png',
    notificationSettings: 'assets/banners/notification-settings-thumbnail.png',
    backInStockSubscription: 'assets/banners/back-in-stock-subscription-thumbnail.png',
    shopifyIntegration: 'assets/banners/shopify-integration-thumbnail.png',
    templateLibrary: 'assets/banners/template-library-thumbnail.png',
    thirdPartyIntegration: 'assets/banners/third-party-integration-thumbnail.png',
    syncOverviewGuide: 'assets/banners/sync-overview-guide.png',
    subscriptionGuide: 'assets/banners/subscription-guide.png',
    translationGuide: 'assets/banners/translation-guide.png',
    variantsDisplayGuideNew: 'assets/banners/variants-display-guide-new.png',
    appPreferencesGuide: 'assets/banners/app-preferences-guide.png',
    globalSellingGuide: 'assets/banners/global-selling-guide.png',
    metafieldsMetaobjectsGuide: 'assets/banners/metafields-metaobjects-guide.png',
    swatchSettingsGuide: 'assets/banners/swatch-settings-guide.png',
    wholesaleSellingGuide: 'assets/banners/wholesale-selling-guide.png',
    sortByOptionsGuide: 'assets/banners/sort-by-options-guide.png',
    relevanceSettingsThumbnail: 'assets/banners/relevance-settings-thumbnail.png',
    inCollectionSearchThumbnail: 'assets/banners/in-collection-search-thumbnail.png',
    instantSearchWidgetThumbnail: 'assets/banners/instant-search-widget-thumbnail.png',
    searchResultsPageThumbnail: 'assets/banners/search-results-page-thumbnail.png',
    manualSynonymsThumbnail: 'assets/banners/manual-synonyms-thumbnail.png',
    suggestionDictionaryThumbnail: 'assets/banners/suggestion-dictionary-thumbnail.png',
    redirectsThumbnail: 'assets/banners/redirects-thumbnail.png',
    stopWordsThumbnail: 'assets/banners/stop-words-thumbnail.png',
    generalSettingsThumbnail: 'assets/banners/general-settings-thumbnail.png',
    semanticSearchThumbnail: 'assets/banners/semantic-search-thumbnail.png',
    aiSynonymsThumbnail: 'assets/banners/ai-synonyms-thumbnail.png',
    productPerformanceRankingThumbnail: 'assets/banners/product-performance-ranking-thumbnail.png',
    searchPersonalizationThumbnail: 'assets/banners/search-personalization-thumbnail.png',
    testYourSearchThumbnail: 'assets/banners/test-your-search-thumbnail.png',
    countdownThumbnail: 'assets/banners/countdown-thumbnail.png'
  },
  campaigns: {
    aiSearchCampaign01: 'assets/campaigns/AI-search-campaign-01.svg',
    aiSearchCampaign02: 'assets/campaigns/AI-search-campaign-02.svg',
    aiSearchCampaign03: 'assets/campaigns/AI-search-campaign-03.svg',
    aiBannerCampaign: 'assets/campaigns/ai-banner-campaign.png',
    bfcm2022: 'assets/campaigns/bfcm2022.png',
    copy: 'assets/campaigns/copy.png',
    help: 'assets/campaigns/help.svg',
    newTabBlue: 'assets/campaigns/new-tab-blue.svg',
    newTab: 'assets/campaigns/new-tab.svg',
    partnerGempages: 'assets/campaigns/partner-gempages.png',
    partnerGrowave: 'assets/campaigns/partner-growave.png',
    partnerLangify: 'assets/campaigns/partner-langify.png',
    partnerVajro: 'assets/campaigns/partner-vajro.png',
    pprCampaignPopup: 'assets/campaigns/ppr-campaign-popup.svg',
    starIcon: 'assets/campaigns/star-icon.png',
    xmas2022: 'assets/campaigns/xmas2022.png',
    freemiumCampaign3rdIntegration: 'assets/campaigns/freemium-campaign-3rd-integration.png',
    freemiumCampaignAiSynonym: 'assets/campaigns/freemium-campaign-ai-synonym.png',
    freemiumCampaignFilterTree: 'assets/campaigns/freemium-campaign-filter-tree.png',
    freemiumCampaignGeneralSettings: 'assets/campaigns/freemium-campaign-general-settings.png',
    freemiumCampaignMerchandising: 'assets/campaigns/freemium-campaign-merchandising.png',
    freemiumCampaignPerformanceRanking:
      'assets/campaigns/freemium-campaign-performance-ranking.png',
    freemiumCampaignPersonalization: 'assets/campaigns/freemium-campaign-personalization.png',
    freemiumCampaignPreOrder: 'assets/campaigns/freemium-campaign-pre-order.png',
    freemiumCampaignPremiumFeatures: 'assets/campaigns/freemium-campaign-premium-features.png',
    freemiumCampaignRecommendation: 'assets/campaigns/freemium-campaign-recommendation.png',
    freemiumCampaignSemanticSearch: 'assets/campaigns/freemium-campaign-semantic-search.png',
    turboCampaignBanner: 'assets/campaigns/turbo-campaign-banner.png',
    turboCampaign2Banner1: 'assets/campaigns/Banner01-Smart-Bundles.png',
    turboCampaign2Banner2: 'assets/campaigns/Banner02-Klaviyo-banner.png',
    turboCampaign2Banner3: 'assets/campaigns/Banner03-Back-in-stock.png',
    turboCampaign2Banner4: 'assets/campaigns/Banner04-Preorder-banner.png'
  },
  common: {
    bfcm2021OfferDe: 'assets/common/BFCM-2021-offer-de.png',
    bfcm2021Offer: 'assets/common/BFCM-2021-offer.png',
    bfcm2023BannerAnalytic: 'assets/common/BFCM-2023-banner-analytic.png',
    bfcm2023BannerPlan: 'assets/common/BFCM-2023-banner-plan.png',
    circleCancelMajor: 'assets/common/circle-cancel-major.svg',
    affiliateProgramPresent: 'assets/common/affiliate-program-present.png',
    aiPoweredIcon: 'assets/common/ai-powered-icon.png',
    alarmClock: 'assets/common/alarm-clock.png',
    analyticAddOn: 'assets/common/analytic-add-on.png',
    arrowRightMinor: 'assets/common/arrow-right-minor.png',
    backgroundWarningMini: 'assets/common/background-warning-mini.png',
    circleAlertInfoIcon: 'assets/common/circle-alert-info-icon.svg',
    diamondAlertMajor: 'assets/common/diamond-alert_major.svg',
    bfcm2350: 'assets/common/bfcm23-50.png',
    bookIcon: 'assets/common/book-icon.png',
    bookmark: 'assets/common/bookmark.svg',
    bottomCenter: 'assets/common/bottom-center.svg',
    bottomLeft: 'assets/common/bottom-left.svg',
    bottomRight: 'assets/common/bottom-right.svg',
    bottom: 'assets/common/bottom.svg',
    central: 'assets/common/central.svg',
    checkCircle: 'assets/common/check-circle.svg',
    chevronDownMinor: 'assets/common/chevron-down-minor.png',
    chevronDown: 'assets/common/chevron-down.svg',
    chevronUpMinor: 'assets/common/chevron-up-minor.png',
    chevronUp: 'assets/common/chevron-up.svg',
    collapseSquareUp: 'assets/common/collapse-square-up.png',
    crownIc: 'assets/common/crown-ic.svg',
    crownRedDisabled: 'assets/common/crown-red-disabled.png',
    crownRed: 'assets/common/crown-red.png',
    crown: 'assets/common/crown.png',
    crownSuccess: 'assets/common/crown-success.png',
    deleteMinor: 'assets/common/delete_minor.svg',
    externalSmallMinor: 'assets/common/external-small_minor.svg',
    flatLinearIcon: 'assets/common/flat-linear-icon.png',
    hand: 'assets/common/hand.svg',
    hourglass: 'assets/common/hourglass.png',
    imageSkeletonLongSmall: 'assets/common/image-skeleton-long-small.png',
    imageSkeletonLong: 'assets/common/image-skeleton-long.png',
    imageSkeleton: 'assets/common/image-skeleton.png',
    infoMinorIcon: 'assets/common/info-minor-icon.png',
    ledger: 'assets/common/ledger.svg',
    left: 'assets/common/left.svg',
    listSearchIcon: 'assets/common/list-search-icon.png',
    lockIcon: 'assets/common/lock-icon.png',
    lock: 'assets/common/lock.svg',
    magicBadgeWarning: 'assets/common/magic-badge-warning.png',
    magicSparkles2: 'assets/common/magic-sparkles-2.png',
    magicSparklesIcon: 'assets/common/magic-sparkles-icon.png',
    menuClose: 'assets/common/menu-close.png',
    menu: 'assets/common/menu.png',
    middleLeft: 'assets/common/middle-left.svg',
    middleRight: 'assets/common/middle-right.svg',
    middle: 'assets/common/middle.svg',
    mobileAcceptMajor: 'assets/common/mobile-accept_major.png',
    newUpdateIcon: 'assets/common/new-update-icon.png',
    placementPreOrder: 'assets/common/placement-pre-order.svg',
    plusWhite: 'assets/common/plus-white.svg',
    plus: 'assets/common/plus.svg',
    popupPreLaunchBackground: 'assets/common/popup-pre-launch-background.png',
    quickView: 'assets/common/quick-view.svg',
    referralBenefit: 'assets/common/referral-benefit.png',
    refresh: 'assets/common/refresh.svg',
    refreshBlue: 'assets/common/refresh-blue.svg',
    removeButtonLiveThemePlacement: 'assets/common/remove-button-live-theme-placement.svg',
    right: 'assets/common/right.svg',
    rocketIcon: 'assets/common/rocket-icon.png',
    rocket: 'assets/common/rocket.svg',
    running: 'assets/common/running.svg',
    region: 'assets/common/globe.png',
    sale2X: 'assets/common/sale-2x.png',
    stars2X: 'assets/common/stars-2x.svg',
    starsRed: 'assets/common/stars-red.svg',
    stars: 'assets/common/stars.svg',
    syncWhite: 'assets/common/sync-white.svg',
    syncFail: 'assets/common/sync.fail.svg',
    syncRunning: 'assets/common/sync.running.svg',
    sync: 'assets/common/sync.svg',
    syncWarn: 'assets/common/sync.warn.svg',
    selectMinorIcon: 'assets/select_minor.png',
    testSearchIcon: 'assets/common/test-search-icon.png',
    timerIcon: 'assets/common/timer-icon.png',
    toggleOff: 'assets/common/toggle-off.svg',
    toggleOn: 'assets/common/toggle-on.svg',
    topCenter: 'assets/common/top-center.svg',
    topLeft: 'assets/common/top-left.svg',
    topRight: 'assets/common/top-right.svg',
    top: 'assets/common/top.svg',
    transparent: 'assets/common/transparent.svg',
    unionIcon: 'assets/common/union-icon.png',
    union: 'assets/common/union.svg',
    unlockStar: 'assets/common/unlock-star.png',
    warning: 'assets/common/warning.svg',
    waveColoringIcon: 'assets/common/wave-coloring-icon.png',
    waveIcon: 'assets/common/wave-icon.png',
    waveLargeIcon: 'assets/common/wave-large-icon.png',
    waveMinorWarning: 'assets/common/wave-minor-warning.png',
    waveWarningIcon: 'assets/common/wave-warning-icon.png',
    wavingHandIcon: 'assets/common/waving-hand-icon.png',
    shoppingBag: 'assets/common/shopping-bag.png',
    pinkCurves: 'assets/common/pink-curves.png',
    Rocket: 'assets/common/rocket.svg',
    Ledger: 'assets/common/ledger.svg',
    warningTriangle: 'assets/common/warning-triangle.svg',
    recommendation: 'assets/common/recommendation.svg',
    analytics: 'assets/common/analytics.svg',
    advancedSearch: 'assets/common/advanced-search.svg',
    canadaFlag: 'assets/common/canada-flag.png',
    dropdownMinorIcon: 'assets/common/dropdown-minor.png',
    ideaIc: 'assets/common/idea-ic.svg',
    bell: 'assets/common/bell.svg',
    iconCheckBlue: 'assets/common/icon-check-blue.svg',
    iconCheckPink: 'assets/common/icon-check-pink.svg',
    storeDefault: 'assets/common/store.png',
    companyBag: 'assets/common/company.png'
  },
  csatFeedback: {
    closeIcon: 'assets/csat-feedback/close-icon.svg',
    decor: 'assets/csat-feedback/decor.svg',
    excellentIcon: 'assets/csat-feedback/excellent-icon.svg',
    goodIcon: 'assets/csat-feedback/good-icon.svg',
    okIcon: 'assets/csat-feedback/ok-icon.svg',
    poorIcon: 'assets/csat-feedback/poor-icon.svg',
    smileIcon: 'assets/csat-feedback/smile-icon.svg'
  },
  dashboard: {
    congrat: 'assets/dashboard/congrat.png',
    expReviewRating: {
      expReviewRating: 'assets/dashboard/expReviewRating/expReviewRating.png',
      expReviewRatingSubmittedFeedback:
        'assets/dashboard/expReviewRating/expReviewRatingSubmittedFeedback.png',
      expReviewRatingSubmittedFeedback2:
        'assets/dashboard/expReviewRating/expReviewRatingSubmittedFeedback2.png',
      likeIcon: 'assets/dashboard/expReviewRating/like-icon.png',
      modal: {
        bg: 'assets/dashboard/expReviewRating/modal/bg.png',
        bgFeedback: 'assets/dashboard/expReviewRating/modal/bg_Feedback.png',
        heartEmoji: 'assets/dashboard/expReviewRating/modal/heartEmoji.png',
        loveEmoji: 'assets/dashboard/expReviewRating/modal/loveEmoji.png',
        sadEmoji: 'assets/dashboard/expReviewRating/modal/sadEmoji.png'
      },
      tadaIcon: 'assets/dashboard/expReviewRating/tada-icon.png'
    },
    feedback: 'assets/dashboard/feedback.png',
    german: 'assets/dashboard/german.png',
    inAppPopupSliders: {
      aiPowerSearch: 'assets/dashboard/in-app-popup-sliders/ai-power-search.png',
      recommendation: 'assets/dashboard/in-app-popup-sliders/recommendation.png',
      visualMerchandising: 'assets/dashboard/in-app-popup-sliders/visual-merchandising.png'
    },
    knowledgebase101: 'assets/dashboard/knowledgebase1_01.png',
    knowledgebase102: 'assets/dashboard/knowledgebase1_02.png',
    knowledgebase103: 'assets/dashboard/knowledgebase1_03.png',
    knowledgebase201: 'assets/dashboard/knowledgebase2_01.png',
    knowledgebase202: 'assets/dashboard/knowledgebase2_02.png',
    newFeatureOnBoard: {
      bannerImage: 'assets/dashboard/newFeatureOnBoard/banner-image.png',
      boostLogo: 'assets/dashboard/newFeatureOnBoard/boost-logo.png',
      chartIcon: 'assets/dashboard/newFeatureOnBoard/chart-icon.png',
      checkCircleIcon: 'assets/dashboard/newFeatureOnBoard/check-circle-icon.png',
      homeIcon: 'assets/dashboard/newFeatureOnBoard/home-icon.png',
      lastStepBanner: 'assets/dashboard/newFeatureOnBoard/last-step-banner.png',
      searchIcon: 'assets/dashboard/newFeatureOnBoard/search-icon.png',
      speaker: 'assets/dashboard/newFeatureOnBoard/speaker.png',
      themeIcon: 'assets/dashboard/newFeatureOnBoard/theme-icon.png'
    },
    noTheme: 'assets/dashboard/no_theme.png',
    notLive: 'assets/dashboard/not_live.png',
    onboarding: {
      enableTheme: 'assets/dashboard/onboarding/enable-theme.png',
      filterStyle: 'assets/dashboard/onboarding/filter-style.png',
      filterTree: 'assets/dashboard/onboarding/filter-tree.png',
      mergeValues: 'assets/dashboard/onboarding/merge-values.png',
      productRanking: 'assets/dashboard/onboarding/product-ranking.png',
      suggestionDictionary: 'assets/dashboard/onboarding/suggestion-dictionary.png',
      swatchSettings: 'assets/dashboard/onboarding/swatch-settings.png',
      collectionFeature4x: 'assets/onboarding/collection-filters-feature4x.png',
      searchWithFilterFeature4x: 'assets/onboarding/search-page-with-filters-feature4x.png',
      iswFeature4x: 'assets/onboarding/isw-feature4x.png'
    },
    optionEmail: 'assets/dashboard/optionEmail.png',
    recommendedApps: {
      aiTrillion: 'assets/dashboard/recommendedApps/aiTrillion.png',
      avada: 'assets/dashboard/recommendedApps/avada.png',
      backInStockRestock: 'assets/dashboard/recommendedApps/backInStockRestock.png',
      litextention: 'assets/dashboard/recommendedApps/litextention.png',
      shopney: 'assets/dashboard/recommendedApps/shopney.png',
      yotpo: 'assets/dashboard/recommendedApps/yotpo.png'
    },
    remove: 'assets/dashboard/remove.png',
    review: 'assets/dashboard/review.png',
    sync: 'assets/dashboard/sync.png',
    welcome: 'assets/dashboard/welcome.png',
    wellInstalled: 'assets/dashboard/well_installed.png'
  },
  dashboardV3: {
    addonBackground: 'assets/dashboard-v3/addon-background.png',
    appInsight: {
      down: {
        down1: 'assets/dashboard-v3/app-insight/down/down1.svg',
        down10: 'assets/dashboard-v3/app-insight/down/down10.svg',
        down2: 'assets/dashboard-v3/app-insight/down/down2.svg',
        down3: 'assets/dashboard-v3/app-insight/down/down3.svg',
        down4: 'assets/dashboard-v3/app-insight/down/down4.svg',
        down5: 'assets/dashboard-v3/app-insight/down/down5.svg',
        down6: 'assets/dashboard-v3/app-insight/down/down6.svg',
        down7: 'assets/dashboard-v3/app-insight/down/down7.svg',
        down8: 'assets/dashboard-v3/app-insight/down/down8.svg',
        down9: 'assets/dashboard-v3/app-insight/down/down9.svg'
      },
      up: {
        up1: 'assets/dashboard-v3/app-insight/up/up1.svg',
        up10: 'assets/dashboard-v3/app-insight/up/up10.svg',
        up2: 'assets/dashboard-v3/app-insight/up/up2.svg',
        up3: 'assets/dashboard-v3/app-insight/up/up3.svg',
        up4: 'assets/dashboard-v3/app-insight/up/up4.svg',
        up5: 'assets/dashboard-v3/app-insight/up/up5.svg',
        up6: 'assets/dashboard-v3/app-insight/up/up6.svg',
        up7: 'assets/dashboard-v3/app-insight/up/up7.svg',
        up8: 'assets/dashboard-v3/app-insight/up/up8.svg',
        up9: 'assets/dashboard-v3/app-insight/up/up9.svg'
      }
    },
    badgeAi: 'assets/dashboard-v3/badge-ai.svg',
    bfcm23InAppPopup: 'assets/dashboard-v3/bfcm23-in-app-popup.png',
    bgQr: 'assets/dashboard-v3/bg-qr.png',
    boostTurboV2: 'assets/dashboard-v3/boost-turbo-v2.png',
    boostTurbo: 'assets/dashboard-v3/boost-turbo.png',
    boost: 'assets/dashboard-v3/boost.png',
    featureBackground: 'assets/dashboard-v3/feature-background.png',
    blueStar: 'assets/dashboard-v3/blue-star.svg',
    greenStar: 'assets/dashboard-v3/green-star.svg',
    getSupport: {
      chatIcon: 'assets/dashboard-v3/get-support/chat-icon.png',
      emailIcon: 'assets/dashboard-v3/get-support/email-icon.png',
      noteIcon: 'assets/dashboard-v3/get-support/note-icon.png',
      phoneIcon: 'assets/dashboard-v3/get-support/phone-icon.png',
      questionIcon: 'assets/dashboard-v3/get-support/question-icon.png',
      sendIcon: 'assets/dashboard-v3/get-support/send-icon.png',
      watchIcon: 'assets/dashboard-v3/get-support/watch-icon.png'
    },
    iconsUpsell: {
      addonCol: 'assets/dashboard-v3/icons-upsell/addon-col.svg',
      addonRec: 'assets/dashboard-v3/icons-upsell/addon-rec.svg',
      addonSearch: 'assets/dashboard-v3/icons-upsell/addon-search.svg',
      addonVariant: 'assets/dashboard-v3/icons-upsell/addon-variant.svg',
      fAnalytic: 'assets/dashboard-v3/icons-upsell/f-analytic.svg',
      fFilter: 'assets/dashboard-v3/icons-upsell/f-filter.svg',
      fInstant: 'assets/dashboard-v3/icons-upsell/f-instant.svg',
      fMerchan: 'assets/dashboard-v3/icons-upsell/f-merchan.svg',
      fRec: 'assets/dashboard-v3/icons-upsell/f-rec.svg',
      fSwatch: 'assets/dashboard-v3/icons-upsell/f-swatch.svg',
      fSynonym: 'assets/dashboard-v3/icons-upsell/f-synonym.svg',
      store: 'assets/dashboard-v3/icons-upsell/store.svg',
      AddonColIcon: 'assets/dashboard-v3/icons-upsell/addon-col.svg',
      AddonRecIcon: 'assets/dashboard-v3/icons-upsell/addon-rec.svg',
      AddonSearchIcon: 'assets/dashboard-v3/icons-upsell/addon-search.svg',
      AddonVariantIcon: 'assets/dashboard-v3/icons-upsell/addon-variant.svg',
      FAnalyticIcon: 'assets/dashboard-v3/icons-upsell/f-analytic.svg',
      FFilterIcon: 'assets/dashboard-v3/icons-upsell/f-filter.svg',
      FInstantIcon: 'assets/dashboard-v3/icons-upsell/f-instant.svg',
      FMerchanIcon: 'assets/dashboard-v3/icons-upsell/f-merchan.svg',
      FRecIcon: 'assets/dashboard-v3/icons-upsell/f-rec.svg',
      FSwatchIcon: 'assets/dashboard-v3/icons-upsell/f-swatch.svg',
      FSynonymIcon: 'assets/dashboard-v3/icons-upsell/f-synonym.svg',
      StoreIcon: 'assets/dashboard-v3/icons-upsell/store.svg'
    },
    likeReview2: 'assets/dashboard-v3/like-review-2.png',
    likeReview: 'assets/dashboard-v3/like-review.png',
    loadingIcon: 'assets/dashboard-v3/loading-icon.png',
    noThemeStatus: 'assets/dashboard-v3/no-theme-status.png',
    notLiveTheme: 'assets/dashboard-v3/not-live-theme.png',
    obRating: 'assets/dashboard-v3/ob-rating.png',
    optionEmail: 'assets/dashboard-v3/option-email.png',
    otherBackground: 'assets/dashboard-v3/other-background.png',
    partners: {
      address: 'assets/dashboard-v3/partners/address.png',
      appikon: 'assets/dashboard-v3/partners/appikon.png',
      bundle: 'assets/dashboard-v3/partners/bundle.png',
      honey: 'assets/dashboard-v3/partners/honey.png',
      influence: 'assets/dashboard-v3/partners/influence.png',
      reviewio: 'assets/dashboard-v3/partners/reviewio.png',
      richreturn: 'assets/dashboard-v3/partners/richreturn.png',
      ultimate: 'assets/dashboard-v3/partners/ultimate.png',
      viral: 'assets/dashboard-v3/partners/viral.png',
      logoAddress: 'assets/dashboard-v3/partners/address.png',
      logoAppikon: 'assets/dashboard-v3/partners/appikon.png',
      logoBundle: 'assets/dashboard-v3/partners/bundle.png',
      logoHoney: 'assets/dashboard-v3/partners/honey.png',
      logoInfluence: 'assets/dashboard-v3/partners/influence.png',
      logoReviewio: 'assets/dashboard-v3/partners/reviewio.png',
      logoRichreturn: 'assets/dashboard-v3/partners/richreturn.png',
      logoUltimate: 'assets/dashboard-v3/partners/ultimate.png',
      logoViral: 'assets/dashboard-v3/partners/viral.png'
    },
    qrWhatsapp: 'assets/dashboard-v3/qr-whatsapp.png',
    ratingSuccess: 'assets/dashboard-v3/rating-success.svg',
    recommendedApps: {
      app01: 'assets/dashboard-v3/recommendedApps/app01.png',
      app02: 'assets/dashboard-v3/recommendedApps/app02.png',
      app03: 'assets/dashboard-v3/recommendedApps/app03.png',
      app04: 'assets/dashboard-v3/recommendedApps/app04.png',
      app05: 'assets/dashboard-v3/recommendedApps/app05.png',
      app06: 'assets/dashboard-v3/recommendedApps/app06.png'
    },
    smiley: 'assets/dashboard-v3/smiley.svg',
    star: 'assets/dashboard-v3/star.svg',
    syncGif: 'assets/dashboard-v3/sync-gif.gif',
    themeStatusSuccess: 'assets/dashboard-v3/theme-status-success.png',
    turboDashboard: 'assets/dashboard-v3/turbo-dashboard.png',
    turboSi: 'assets/dashboard-v3/turbo-si.png',
    uncheckIcon: 'assets/dashboard-v3/uncheck-icon.png',
    v3ToTurboDashboard: 'assets/dashboard-v3/v3-to-turbo-dashboard.png',
    v3ToTurboThemeSetup: 'assets/dashboard-v3/v3-to-turbo-theme-setup.png',
    yepPopup2023: 'assets/dashboard-v3/yep-popup-2023.png',
    IconSmiley: 'assets/dashboard-v3/smiley.svg',
    OBRating: 'assets/dashboard-v3/ob-rating.png',
    Star: 'assets/dashboard-v3/star.svg',
    BadgeAIIcon: 'assets/dashboard-v3/badge-ai.svg',
    syncLoadingIcon: 'assets/dashboard-v3/sync-gif.gif',
    V3ToTurboDashboard: 'assets/dashboard-v3/v3-to-turbo-dashboard.png',
    TurboThemeSetup: 'assets/dashboard-v3/v3-to-turbo-theme-setup.png',
    TurboDashboard: 'assets/dashboard-v3/turbo-dashboard.png',
    TurboSI: 'assets/dashboard-v3/turbo-si.png',
    LikeRating: 'assets/dashboard-v3/like-review.png',
    LikeRating2: 'assets/dashboard-v3/like-review-2.png',
    RatingSuccess: 'assets/dashboard-v3/rating-success.svg'
  },
  feedbackAfter5StarsRating: {
    1: 'assets/feedback-after-5-stars-rating/1.png',
    2: 'assets/feedback-after-5-stars-rating/2.png',
    3: 'assets/feedback-after-5-stars-rating/3.png',
    4: 'assets/feedback-after-5-stars-rating/4.png',
    5: 'assets/feedback-after-5-stars-rating/5.png',
    bgAllSet: 'assets/feedback-after-5-stars-rating/bg-all-set.png',
    gift: 'assets/feedback-after-5-stars-rating/gift.svg',
    smile: 'assets/feedback-after-5-stars-rating/smile.png'
  },
  filterLayout: {
    horizontal: {
      expand: 'assets/filter-layout/horizontal/expand.png',
      expandGif: 'assets/filter-layout/horizontal/expand.gif',
      oneColumn: 'assets/filter-layout/horizontal/oneColumn.png',
      oneColumnGif: 'assets/filter-layout/horizontal/oneColumn.gif',
      threeColumns: 'assets/filter-layout/horizontal/threeColumns.png',
      threeColumnsGif: 'assets/filter-layout/horizontal/threeColumns.gif',
      twoColumns: 'assets/filter-layout/horizontal/twoColumns.png',
      twoColumnsGif: 'assets/filter-layout/horizontal/twoColumns.gif'
    },
    mobile: {
      defaultOffCanvas: 'assets/filter-layout/mobile/default-offCanvas.png',
      defaultOffCanvasGif: 'assets/filter-layout/mobile/default-offCanvas.gif',
      expand: 'assets/filter-layout/mobile/expand.png',
      expandGif: 'assets/filter-layout/mobile/expand.gif',
      fullwidth: 'assets/filter-layout/mobile/fullwidth.png',
      fullwidthGif: 'assets/filter-layout/mobile/fullwidth.gif',
      scrollDownFullWidth: 'assets/filter-layout/mobile/scrollDown-fullWidth.png',
      scrollDownFullWidthGif: 'assets/filter-layout/mobile/scrollDown-fullWidth.gif',
      scrollDownOffCanvas: 'assets/filter-layout/mobile/scrollDown-offCanvas.png',
      scrollDownOffCanvasGif: 'assets/filter-layout/mobile/scrollDown-offCanvas.gif'
    },
    vertical: {
      expand: 'assets/filter-layout/vertical/expand.png',
      expandGif: 'assets/filter-layout/vertical/expand.gif',
      leftSide: 'assets/filter-layout/vertical/leftSide.png',
      offCanvas: 'assets/filter-layout/vertical/offCanvas.png',
      offCanvasGif: 'assets/filter-layout/vertical/offCanvas.gif'
    }
  },
  filterTree: {
    bcSfFilterNoImage2: 'assets/filter-tree/bc-sf-filter-no-image-2.png',
    bcSfFilterNoImage: 'assets/filter-tree/bc-sf-filter-no-image.gif',
    emptyOption: 'assets/filter-tree/empty-option.png',
    'bcSfFilterNoImage-2': 'assets/filter-tree/bc-sf-filter-no-image-2.png'
  },
  inApp: {
    empty: 'assets/in-app/empty.png',
    landingPage: 'assets/in-app/landing-page.png'
  },
  install: {
    layoutHorizontal: 'assets/install/layout-horizontal.png',
    layoutVertical: 'assets/install/layout-vertical.png',
    slideshow: {
      1: 'assets/install/slideshow/1.png',
      2: 'assets/install/slideshow/2.png',
      3: 'assets/install/slideshow/3.png',
      4: 'assets/install/slideshow/4.png',
      5: 'assets/install/slideshow/5.png',
      6: 'assets/install/slideshow/6.png',
      7: 'assets/install/slideshow/7.png',
      8: 'assets/install/slideshow/8.png'
    }
  },
  installation: {
    email: 'assets/onboarding/email-opt.png',
    emailSmall: 'assets/onboarding/email-otp-small.png',
    circleCheckSpot: 'assets/installation/circle-check_spot.svg',
    featureFilter2X: 'assets/installation/feature-filter-2x.png',
    featureFilter: 'assets/installation/feature-filter.png',
    featureSearch2X: 'assets/installation/feature-search-2x.png',
    featureSearch: 'assets/installation/feature-search.png',
    featureRecommendation2X: 'assets/installation/feature-recommendation-2x.png',
    featureRecommendation: 'assets/installation/feature-recommendation.png',
    featureVisual2X: 'assets/installation/feature-visual-2x.png',
    featureVisual: 'assets/installation/feature-visual.png',
    iconFilter: 'assets/installation/icon-filter.svg',
    iconRecommendation: 'assets/installation/icon-recommendation.svg',
    iconSearch: 'assets/installation/icon-search.svg',
    iconVisual: 'assets/installation/icon-visual.svg',
    iconRefresh: 'assets/installation/icon-refresh.svg',
    runningSync: 'assets/installation/running-sync.gif',
    runningThemeSetupSuccess: 'assets/installation/running-theme-setup-success.gif',
    runningThemeSetupFail: 'assets/installation/running-theme-setup-fail.gif',
    running2X: 'assets/installation/running-2x.gif',
    successInstall2X: 'assets/installation/success-install-2x.png',
    onboarding12X: 'assets/installation/onboarding1-2x.png',
    onboarding22X: 'assets/installation/onboarding2-2x.png',
    onboarding32X: 'assets/installation/onboarding3-2x.png',
    onboarding42X: 'assets/installation/onboarding4-2x.png',
    onboarding52X: 'assets/installation/onboarding5-2x.png',
    onboarding62X: 'assets/installation/onboarding6-2x.png',
    selectFeatureCollection: 'assets/installation/select-feature-collection.png',
    selectFeatureSearch: 'assets/installation/select-feature-search.png',
    selectFeatureOthers: 'assets/installation/select-feature-others.png',
    selectFeatureInstantSearch: 'assets/installation/select-feature-instant-search.png'
  },
  instantSearchWidget: {
    style1Grid: 'assets/instant-search-widget/style1-grid.png',
    style1List: 'assets/instant-search-widget/style1-list.png',
    style2GridLeft: 'assets/instant-search-widget/style2-grid-left.png',
    style2GridRight: 'assets/instant-search-widget/style2-grid-right.png',
    style2ListLeft1: 'assets/instant-search-widget/style2-list-left-1.png',
    style2ListLeft2: 'assets/instant-search-widget/style2-list-left-2.png',
    style2ListRight1: 'assets/instant-search-widget/style2-list-right-1.png',
    style2ListRight2: 'assets/instant-search-widget/style2-list-right-2.png',
    style3GridLeft: 'assets/instant-search-widget/style3-grid-left.png',
    style3GridRight: 'assets/instant-search-widget/style3-grid-right.png',
    style3ListLeft2: 'assets/instant-search-widget/style3-list-left-2.png',
    style3ListLeft3: 'assets/instant-search-widget/style3-list-left-3.png',
    style3ListRight2: 'assets/instant-search-widget/style3-list-right-2.png',
    style3ListRight3: 'assets/instant-search-widget/style3-list-right-3.png'
  },
  integration: {
    aliReview: 'assets/integration/ali-review.png',
    appBanner01: 'assets/integration/app-banner-01.png',
    appBanner02: 'assets/integration/app-banner-02.png',
    attentive: 'assets/integration/attentive-v2.png',
    bestCurrencyConverter: 'assets/integration/best-currency-converter.png',
    collectionSwatchPug: 'assets/integration/collection-swatch-pug.png',
    discountNinja: 'assets/integration/discount-ninja.png',
    fera: 'assets/integration/fera.png',
    flairProductBadgesLabels: 'assets/integration/flair-v2.png',
    gempages: 'assets/integration/gempages.png',
    iWishlist: 'assets/integration/i-wishlist.png',
    judgemeProductReviews: 'assets/integration/judge-me-v2.png',
    klaviyo: 'assets/integration/klaviyo.svg',
    laiAliExpress: 'assets/integration/lai-ali-express.png',
    langify: 'assets/integration/langify.png',
    langshop: 'assets/integration/langshop.png',
    looxReviews: 'assets/integration/loox-reviews.png',
    mlvAutoCurrencySwitcher: 'assets/integration/mlv-auto-currency-switcher.png',
    okendo: 'assets/integration/okendo.png',
    productCompare: 'assets/integration/product-compare.png',
    productLabels: 'assets/integration/deco-v2.png',
    productReviewsShopify: 'assets/integration/product-reviews-shopify.png',
    quickViewBySecomapp: 'assets/integration/quick-view-by-secomapp.png',
    reviewsIo: 'assets/integration/reviews-io.png',
    reviewsLoyaltyWishlist: 'assets/integration/reviews-loyalty-wishlist.png',
    rivyoProductReview: 'assets/integration/rivyo-v2.png',
    ryviu: 'assets/integration/ryviu-v2.png',
    shopifyMultiCurrency: 'assets/integration/shopify-multi-currency.png',
    shopney: 'assets/integration/shopney.png',
    small: {
      aliReview: 'assets/integration/small/ali-review.png',
      judgemeProductReviews: 'assets/integration/small/judgeme-product-reviews.png',
      laiAliExpress: 'assets/integration/small/lai-ali-express.png',
      looxReviews: 'assets/integration/small/loox-reviews.png',
      okendo: 'assets/integration/small/okendo.png',
      productReviewsShopify: 'assets/integration/small/product-reviews-shopify.png',
      reviewsIo: 'assets/integration/small/reviews-io.png',
      reviewsLoyaltyWishlist: 'assets/integration/small/reviews-loyalty-wishlist.png',
      rivyoProductReview: 'assets/integration/small/rivyo-product-review.png',
      ryviu: 'assets/integration/small/ryviu.png',
      stampedReviews: 'assets/integration/small/stamped-reviews.png',
      yotpoReviews: 'assets/integration/small/yotpo-reviews.png'
    },
    smartWishlist: 'assets/integration/smart-wishlist.png',
    stampedReviews: 'assets/integration/stamped-v2.png',
    vajro: 'assets/integration/vajro.png',
    weglotTranslate: 'assets/integration/weglot-translate.png',
    wishlistKing: 'assets/integration/wishlist-king-v2.png',
    wishlistPlus: 'assets/integration/wishlist-plus.png',
    yotpoReviews: 'assets/integration/yotpo-v2.png',
    globalE: 'assets/integration/globalE.png',
    globalELarge: 'assets/integration/global-e-large.png',
    gorgias: 'assets/integration/gorgias-livechat.png',
    shopifyCombinedListings: 'assets/integration/shopify-combined-listing.png',
    googleAnalytics4: 'assets/integration/google-analytic-4.png',
  },
  klaviyo: {
    logo: 'assets/klaviyo/logo.png',
    logo2: 'assets/klaviyo/logo2.png',
    icon: 'assets/klaviyo/icon-klaviyo.svg'
  },
  backInStock: {
    notificationPreview: 'assets/back-in-stock/bis-notification-preview.png',
    lockImg: 'assets/back-in-stock/back-in-stock-lock-card.svg',
    guideSettings: 'assets/back-in-stock/back-in-stock-settings-guide.svg',
    guideSubscription: 'assets/back-in-stock/back-in-stock-submission-guide.svg',
    notificationLock: 'assets/back-in-stock/bis-notification-lock-card.png',
    notificationReachLimitLock: 'assets/back-in-stock/lock-notification-settings-img.png'
  },
  preOrder: {
    notificationPreview: 'assets/back-in-stock/bis-notification-preview.png',
    addPreorderToPage: 'assets/preorder/add-preorder-to-page.png'
  },
  landingPage: {
    aiPowered: {
      analyticForecastTrends: 'assets/landing-page/ai-powered/analytic-forecast-trends.png',
      analytics365DayReports: 'assets/landing-page/ai-powered/analytics-365-day-reports.png',
      line1: 'assets/landing-page/ai-powered/line1.svg',
      line2: 'assets/landing-page/ai-powered/line2.svg',
      main: 'assets/landing-page/ai-powered/main.png',
      recommendationFrequentlyBoughtTogether:
        'assets/landing-page/ai-powered/recommendation-frequently-bought-together.png',
      recommendationPersonalization:
        'assets/landing-page/ai-powered/recommendation-personalization.png',
      recommendationRelatedItems: 'assets/landing-page/ai-powered/recommendation-related-items.png',
      searchKeywordSuggestions: 'assets/landing-page/ai-powered/search-keyword-suggestions.png',
      searchPersonalization: 'assets/landing-page/ai-powered/search-personalization.png',
      searchProductPerformanceRanking:
        'assets/landing-page/ai-powered/search-product-performance-ranking.png',
      searchSemantic: 'assets/landing-page/ai-powered/search-semantic.png',
      searchSimulator: 'assets/landing-page/ai-powered/search-simulator.png',
      searchSynonyms: 'assets/landing-page/ai-powered/search-synonyms.png',
      searchTestYourSearch: 'assets/landing-page/ai-powered/search-test-your-search.png',
      transformExperienceWithAi: 'assets/landing-page/ai-powered/transform-experience-with-ai.png'
    },
    turbo: {
      back: 'assets/landing-page/turbo/back.png',
      bannerText: 'assets/landing-page/turbo/banner-text.svg',
      banner: 'assets/landing-page/turbo/banner.png',
      blurBgIntro: 'assets/landing-page/turbo/blur-bg-intro.png',
      blurBgSteps: 'assets/landing-page/turbo/blur-bg-steps.png',
      blurBg: 'assets/landing-page/turbo/blur-bg.svg',
      chart: 'assets/landing-page/turbo/chart.svg',
      close: 'assets/landing-page/turbo/close.png',
      collapse: 'assets/landing-page/turbo/collapse.svg',
      contact: 'assets/landing-page/turbo/contact.svg',
      expand: 'assets/landing-page/turbo/expand.svg',
      howfastCard1: 'assets/landing-page/turbo/howfast.card1.svg',
      howfastCard2: 'assets/landing-page/turbo/howfast.card2.svg',
      howfastEffect: 'assets/landing-page/turbo/howfast.effect.svg',
      howfastStar1: 'assets/landing-page/turbo/howfast.star1.svg',
      howfastStar2: 'assets/landing-page/turbo/howfast.star2.svg',
      iconRight: 'assets/landing-page/turbo/icon-right.svg',
      iconTurbo: 'assets/landing-page/turbo/icon-turbo.svg',
      iconV3: 'assets/landing-page/turbo/icon-v3.svg',
      logoBoostTurbo: 'assets/landing-page/turbo/logo.boost-turbo.svg',
      logoEffect1: 'assets/landing-page/turbo/logo.effect1.png',
      logoEffect2: 'assets/landing-page/turbo/logo.effect2.png',
      logoEffect3: 'assets/landing-page/turbo/logo.effect3.png',
      logo: 'assets/landing-page/turbo/logo.png',
      logoSuperCharge: 'assets/landing-page/turbo/logo.super-charge.svg',
      play: 'assets/landing-page/turbo/play.svg',
      speed: 'assets/landing-page/turbo/speed.svg',
      stepContact: 'assets/landing-page/turbo/step.contact.svg',
      stepIntegration: 'assets/landing-page/turbo/step.integration.svg',
      step1: 'assets/landing-page/turbo/step1.png',
      step2: 'assets/landing-page/turbo/step2.png',
      step3: 'assets/landing-page/turbo/step3.png',
      videoPreview: 'assets/landing-page/turbo/video.preview.png',
      what: 'assets/landing-page/turbo/what.svg',
      whyB2B: 'assets/landing-page/turbo/why.b2b.png',
      whyBlazing: 'assets/landing-page/turbo/why.blazing.svg',
      whyBrand: 'assets/landing-page/turbo/why.brand.svg',
      whyDesign: 'assets/landing-page/turbo/why.design.svg',
      whyEnhanced: 'assets/landing-page/turbo/why.enhanced.svg',
      whyShallow: 'assets/landing-page/turbo/why.shallow.svg',
      whyPredictiveBundles: 'assets/landing-page/turbo/why.predictive-bundles.svg',
      whyPreOrder: 'assets/landing-page/turbo/why.pre-order.svg',
      whyBackInStock: 'assets/landing-page/turbo/why.back-in-stock.svg',
      whyIntegrations: 'assets/landing-page/turbo/why.integrations.svg',
      whyVisualEditor: 'assets/landing-page/turbo/why.enhanced.svg',
      whyCodeEditor: 'assets/landing-page/turbo/why.brand.svg'
    }
  },
  languageSetting: {
    languageSetting: 'assets/language-setting/language-setting.png'
  },
  lockUnlockImage: {
    advanceFilterOption: 'assets/lock-unlock-image/advance-filter-option.svg',
    filterTreeLock: 'assets/lock-unlock-image/filter-tree-lock.svg',
    generalSettingsLock: 'assets/lock-unlock-image/general-settings-lock.svg',
    inCollectionSearchLock: 'assets/lock-unlock-image/in-collection-search-lock.svg',
    manualSynonymLock: 'assets/lock-unlock-image/manual-synonym-lock.svg',
    metafieldLock: 'assets/lock-unlock-image/metafield-lock.svg',
    personalizationLock: 'assets/lock-unlock-image/personalization-lock.svg',
    preOrderAnalyticLock: 'assets/lock-unlock-image/pre-order-analytic-lock.svg',
    predictiveBundleLock: 'assets/lock-unlock-image/predictive-bundle-lock.png',
    redirectLock: 'assets/lock-unlock-image/redirect-lock.svg',
    searchControlBannerLock: 'assets/lock-unlock-image/search-control-banner-lock.svg',
    searchMerchandisingLock: 'assets/lock-unlock-image/search-merchandising-lock.svg',
    searchNoResultLock: 'assets/lock-unlock-image/search-no-result-lock.svg',
    stopWordLock: 'assets/lock-unlock-image/stop-word-lock.svg',
    suggestionDictionaryLock: 'assets/lock-unlock-image/suggestion-dictionary-lock.svg',
    swatchSettingsLock: 'assets/lock-unlock-image/swatch-settings-lock.svg',
    thirdPartyIntegrationLock: 'assets/lock-unlock-image/third-party-integration-lock.svg'
  },
  merchandising: {
    bannerIntroVersion: 'assets/merchandising/banner-intro-version.png',
    bannerPlaceholder: 'assets/merchandising/banner-placeholder.png',
    dress: 'assets/merchandising/dress.svg',
    flame: 'assets/merchandising/flame.svg',
    light: 'assets/merchandising/light.svg',
    lockFeature01: 'assets/merchandising/lock-feature-01.png',
    pageApplyIcon: 'assets/merchandising/page_apply_icon.png',
    welcomeNewMerchandising: 'assets/merchandising/welcome-new-merchandising.png',
    pinSlotsLock: 'assets/merchandising/pin-slots-lock.png'
  },
  migration: {
    slideshow: {
      1: 'assets/migration/slideshow/1.png',
      2: 'assets/migration/slideshow/2.png',
      3: 'assets/migration/slideshow/3.png'
    }
  },
  product: {
    defaultThemeSettings: {
      cutoutCamiDress: {
        armyGreen: {
          armyGreen1:
            'assets/product/default-theme-settings/Cutout Cami Dress/Army Green/Army-Green_1.jpg',
          armyGreen2:
            'assets/product/default-theme-settings/Cutout Cami Dress/Army Green/Army-Green_2.jpg'
        },
        black: {
          black1: 'assets/product/default-theme-settings/Cutout Cami Dress/Black/Black_1.jpg',
          black2: 'assets/product/default-theme-settings/Cutout Cami Dress/Black/Black_2.jpg'
        },
        brown: {
          brown1: 'assets/product/default-theme-settings/Cutout Cami Dress/Brown/Brown_1.jpg',
          brown2: 'assets/product/default-theme-settings/Cutout Cami Dress/Brown/Brown_2.jpg'
        },
        burntOrange: {
          burntOrange1:
            'assets/product/default-theme-settings/Cutout Cami Dress/Burnt Orange/Burnt-Orange_1.jpg',
          burntOrange2:
            'assets/product/default-theme-settings/Cutout Cami Dress/Burnt Orange/Burnt-Orange_2.jpg'
        }
      },
      mecurySilkDress: {
        black: {
          black1: 'assets/product/default-theme-settings/Mecury Silk Dress/Black/Black_1.jpg',
          black2: 'assets/product/default-theme-settings/Mecury Silk Dress/Black/Black_2.jpg'
        },
        blue: {
          blue1: 'assets/product/default-theme-settings/Mecury Silk Dress/Blue/Blue_1.jpg',
          blue2: 'assets/product/default-theme-settings/Mecury Silk Dress/Blue/Blue_2.jpg'
        },
        burntOrange: {
          burntOrange1:
            'assets/product/default-theme-settings/Mecury Silk Dress/Burnt Orange/Burnt-Orange_1.jpg',
          burntOrange2:
            'assets/product/default-theme-settings/Mecury Silk Dress/Burnt Orange/Burnt-Orange_2.jpg'
        },
        oliveGreen: {
          oliveGreen1:
            'assets/product/default-theme-settings/Mecury Silk Dress/Olive Green/Olive-Green_1.jpg',
          oliveGreen2:
            'assets/product/default-theme-settings/Mecury Silk Dress/Olive Green/Olive-Green_2.jpg'
        }
      },
      ruffleFlareDress: {
        black: {
          black1: 'assets/product/default-theme-settings/Ruffle Flare Dress/Black/Black_1.jpg',
          black2: 'assets/product/default-theme-settings/Ruffle Flare Dress/Black/Black_2.jpg'
        },
        brown: {
          brown1: 'assets/product/default-theme-settings/Ruffle Flare Dress/Brown/Brown_1.jpg',
          brown2: 'assets/product/default-theme-settings/Ruffle Flare Dress/Brown/Brown_2.jpg'
        },
        maroon: {
          maroon1: 'assets/product/default-theme-settings/Ruffle Flare Dress/Maroon/Maroon_1.jpg',
          maroon2: 'assets/product/default-theme-settings/Ruffle Flare Dress/Maroon/Maroon_2.jpg'
        }
      }
    },
    noImage: 'assets/product/no-image.png',
    noProductImage: 'assets/product/no-product-image.png',
    productImage: 'assets/product/product-image.png',
    productImageWebp: 'assets/product/product-image.webp'
  },
  quickStartGuide: {
    iconBoostCore: 'assets/quick-start-guide/icon.boost-core.svg',
    iconBoost: 'assets/quick-start-guide/icon.boost.svg',
    iconChat: 'assets/quick-start-guide/icon.chat.svg',
    iconChecked: 'assets/quick-start-guide/icon.checked.svg',
    iconClose: 'assets/quick-start-guide/icon.close.svg',
    iconFilter: 'assets/quick-start-guide/icon.filter.svg',
    iconPreview: 'assets/quick-start-guide/icon.preview.svg',
    iconRecommend: 'assets/quick-start-guide/icon.recommend.svg',
    iconReload: 'assets/quick-start-guide/icon.reload.svg',
    iconSearch: 'assets/quick-start-guide/icon.search.svg',
    iconStar: 'assets/quick-start-guide/icon.star.svg',
    iconUncheck: 'assets/quick-start-guide/radio-uncheck.svg',
    imgFilter1: 'assets/quick-start-guide/img.filter1.svg',
    imgFilter2: 'assets/quick-start-guide/img.filter2.svg',
    imgFilter3: 'assets/quick-start-guide/img.filter3.svg',
    imgFilter4Advanced: 'assets/quick-start-guide/img.filter4.advanced.svg',
    imgFilter5Advanced: 'assets/quick-start-guide/img.filter5.advanced.svg',
    imgPreview1: 'assets/quick-start-guide/img.preview1.svg',
    imgPreview2: 'assets/quick-start-guide/img.preview2.svg',
    imgPreview3: 'assets/quick-start-guide/img.preview3.svg',
    imgPreview4Ssr: 'assets/quick-start-guide/img.preview4.ssr.svg',
    imgRecommend1: 'assets/quick-start-guide/img.recommend1.svg',
    imgRecommend2: 'assets/quick-start-guide/img.recommend2.svg',
    imgSearch1: 'assets/quick-start-guide/img.search1.svg',
    imgSearch2: 'assets/quick-start-guide/img.search2.svg',
    imgSearch3Checked: 'assets/quick-start-guide/img.search3.checked.svg',
    imgSearch3: 'assets/quick-start-guide/img.search3.svg',
    IconReload: 'assets/quick-start-guide/icon.reload.svg',
    IconStar: 'assets/quick-start-guide/icon.star.svg',
    IconChecked: 'assets/quick-start-guide/icon.checked.svg',
    IconUncheck: 'assets/quick-start-guide/icon.uncheck.svg',
    IconBoost: 'assets/quick-start-guide/icon.boost.svg',
    IconFilter: 'assets/quick-start-guide/icon.filter.svg',
    IconSearch: 'assets/quick-start-guide/icon.search.svg',
    IconRecommend: 'assets/quick-start-guide/icon.recommend.svg',
    IconClose: 'assets/quick-start-guide/icon.close.svg',
    IconPreview: 'assets/quick-start-guide/icon.preview.svg',
    IconChat: 'assets/quick-start-guide/icon.chat.svg',
    ImgPreviewSSR: 'assets/quick-start-guide/img.preview4.ssr.svg',
    ImgFilter1: 'assets/quick-start-guide/img.filter1.svg',
    ImgFilter2: 'assets/quick-start-guide/img.filter2.svg',
    ImgFilter3: 'assets/quick-start-guide/img.filter3.svg',
    ImgFilter4Advanced: 'assets/quick-start-guide/img.filter4.advanced.svg',
    ImgFilter5Advanced: 'assets/quick-start-guide/img.filter5.advanced.svg',
    ImgSearch1: 'assets/quick-start-guide/img.search1.svg',
    ImgSearch2: 'assets/quick-start-guide/img.search2.svg',
    ImgRecommend1: 'assets/quick-start-guide/img.recommend1.svg',
    ImgRecommend2: 'assets/quick-start-guide/img.recommend2.svg',
    ImgPreview1: 'assets/quick-start-guide/img.preview1.svg',
    ImgPreview2: 'assets/quick-start-guide/img.preview2.svg',
    ImgPreview3: 'assets/quick-start-guide/img.preview3.svg'
  },
  quickViewCart: {
    buttonStyle: {
      style1: 'assets/quick-view-cart/button-style/style-1.png',
      style2: 'assets/quick-view-cart/button-style/style-2.png',
      style3: 'assets/quick-view-cart/button-style/style-3.png',
      style4De: 'assets/quick-view-cart/button-style/style-4-de.png',
      style4: 'assets/quick-view-cart/button-style/style-4.png',
      style5: 'assets/quick-view-cart/button-style/style-5.png',
      style6De: 'assets/quick-view-cart/button-style/style-6-de.png',
      style6: 'assets/quick-view-cart/button-style/style-6.png'
    },
    tooltip: {
      cartDisplayPopupcart: 'assets/quick-view-cart/tooltip/Cart display_Popupcart.gif',
      cartDisplaySidecart: 'assets/quick-view-cart/tooltip/Cart display_Sidecart.gif',
      selectOptionDisplayMiniPopup:
        'assets/quick-view-cart/tooltip/Select option display_Mini popup.gif',
      selectOptionDisplayPopup: 'assets/quick-view-cart/tooltip/Select option display_Popup.gif'
    }
  },
  recommendation: {
    addAppBlockForBundleOs10: 'assets/recommendation/add-app-block-for-bundle-OS10.png',
    addAppBlockForBundle: 'assets/recommendation/add-app-block-for-bundle.png',
    addAppBlockSsr: 'assets/recommendation/add-app-block-ssr.png',
    addCheckoutBlockSsr: 'assets/recommendation/add-checkout-block-ssr.png',
    addAppBlock: 'assets/recommendation/add-app-block.png',
    addRecommendationToPage: 'assets/recommendation/add-recommendation-to-page.gif',
    addSearchAppBlockOs10Step1: 'assets/recommendation/add-search-app-block-OS10-step1.gif',
    addSearchAppBlockOs10Step2: 'assets/recommendation/add-search-app-block-OS10-step2.gif',
    addSearchAppBlockForBundle: 'assets/recommendation/add-search-app-block-for-bundle.png',
    addVolumeAppBlockForBundle: 'assets/recommendation/add-volume-product-app-block-for-bundle.png',
    addTierAppBlockForBundle: 'assets/recommendation/add-tier-product-app-block-for-bundle.png',
    aiFrequentlyBoughtTogetherType: 'assets/recommendation/ai-frequently-bought-together-type.png',
    aiPersonalizedBundleType: 'assets/recommendation/ai-personalized-bundle-type.png',
    aiRelatedItemsType: 'assets/recommendation/ai-related-items-type.png',
    volumeBundleType: 'assets/recommendation/volume-discount-bundle-type-img.png',
    bundle: {
      enableBoostCoreSsr: 'assets/recommendation/bundle/enable-boost-core-ssr.png',
      enableIswBlock: 'assets/recommendation/bundle/enable-isw-block.png',
      newSIBothSearch: 'assets/recommendation/new-SI-placement-both.png',
      newSInstantSearch: 'assets/recommendation/new-SI-placement01.png',
      newSSearchResult: 'assets/recommendation/new-SI-placement02.png',
      addSearchAppBlockForBundle: 'assets/recommendation/bundle/add-search-app-block-for-bundle.png'
    },
    bundleDisplayTypeBottom: 'assets/recommendation/bundle-display-type-bottom.png',
    bundleDisplayTypeProduct: 'assets/recommendation/bundle-display-type-product.png',
    classicBundleType: 'assets/recommendation/classic-bundle-type.png',
    tieredDiscountBundleType: 'assets/recommendation/tiered-discount-bundle-type-img.png',
    createBoostAppFile: 'assets/recommendation/create-boost-app-file.gif',
    emptyResults: 'assets/recommendation/empty-results.svg',
    enableBoostCoreSsr: 'assets/recommendation/enable-boost-core-ssr.png',
    enableBoostCore: 'assets/recommendation/enable-boost-core.png',
    gradientHorizontal: 'assets/recommendation/gradient-horizontal.png',
    personalizationPresentBannerTagline:
      'assets/recommendation/personalization-present-banner-tagline.png',
    personalizationPresentBanner: 'assets/recommendation/personalization-present-banner.png',
    recommendGeneralSettings: 'assets/recommendation/recommend-general-settings.png',
    plusPlanBanner: 'assets/recommendation/shopify-plus-checkout-page-banner.png',
    enableCartDrawer: 'assets/recommendation/enable-cart-drawer.png'
  },
  shopifyIntegration: {
    404: 'assets/shopify-integration/404.svg',
    boostLogo: 'assets/shopify-integration/BoostLogo.png',
    boostSnippetDemo: 'assets/shopify-integration/BoostSnippetDemo.jpg',
    boostSnippetDemo2: 'assets/shopify-integration/BoostSnippetDemo2.png',
    dot: 'assets/shopify-integration/Dot.svg',
    editCode: 'assets/shopify-integration/EditCode.gif',
    emptyContent: 'assets/shopify-integration/EmptyContent.png',
    enableBoostCore: 'assets/shopify-integration/EnableBoostCore.gif',
    guideCollectionPageOs10Step1: 'assets/shopify-integration/GuideCollectionPageOS10Step1.gif',
    guideCollectionPageOs10Step2: 'assets/shopify-integration/GuideCollectionPageOS10Step2.gif',
    guideCollectionPageStep1: 'assets/shopify-integration/GuideCollectionPageStep1.png',
    guideCollectionPageStep2: 'assets/shopify-integration/GuideCollectionPageStep2.png',
    guideIsw: 'assets/shopify-integration/GuideISW.png',
    guideRecOs10Step1: 'assets/shopify-integration/GuideRecOS10Step1.gif',
    guideRecStep1: 'assets/shopify-integration/GuideRecStep1.png',
    guideSearchPageOs10Step1: 'assets/shopify-integration/GuideSearchPageOS10Step1.gif',
    guideSearchPageOs10Step2: 'assets/shopify-integration/GuideSearchPageOS10Step2.gif',
    guideSearchPageStep1: 'assets/shopify-integration/GuideSearchPageStep1.png',
    guideSearchPageStep2: 'assets/shopify-integration/GuideSearchPageStep2.png',
    previewBasicTemplate: 'assets/shopify-integration/PreviewBasicTemplate.png',
    previewDefaultTemplate: 'assets/shopify-integration/PreviewDefaultTemplate.png',
    previewIconicTemplate: 'assets/shopify-integration/PreviewIconicTemplate.png',
    previewSummerTemplate: 'assets/shopify-integration/PreviewSummerTemplate.png',
    previewWaveTechTemplate: 'assets/shopify-integration/PreviewWaveTechTemplate.png',
    previewEleganceTemplate: 'assets/shopify-integration/PreviewEleganceTemplate.png',
    previewPrimeTemplate: 'assets/shopify-integration/PreviewPrimeTemplate.png',
    previewEpicTemplate: 'assets/shopify-integration/PreviewEpicTemplate.png',
    previewFamousTemplate: 'assets/shopify-integration/PreviewFamousTemplate.png',
    previewBoundlessTemplate: 'assets/shopify-integration/PreviewBoundlessTemplate.png',
    previewMovementTemplate: 'assets/shopify-integration/PreviewMovementTemplate.png',
    previewVistaTemplate: 'assets/shopify-integration/PreviewVistaTemplate.png',
    previewTimelessTemplate: 'assets/shopify-integration/PreviewTimelessTemplate.png',
    previewFlavorTemplate: 'assets/shopify-integration/PreviewFlavorTemplate.png',
    previewBlushTemplate: 'assets/shopify-integration/PreviewBlushTemplate.png',
    previewSimplifyTemplate: 'assets/shopify-integration/PreviewSimplifyTemplate.png',
    previewHorizonTemplate: 'assets/shopify-integration/PreviewHorizonTemplate.png',
    thumbnailBasicTemplate: 'assets/shopify-integration/ThumbnailBasicTemplate.png',
    thumbnailBasicTemplate224: 'assets/shopify-integration/ThumbnailBasicTemplate224.png',
    thumbnailDefaultTemplate: 'assets/shopify-integration/ThumbnailDefaultTemplate.png',
    thumbnailDefaultTemplate224: 'assets/shopify-integration/ThumbnailDefaultTemplate224.png',
    thumbnailIconicTemplate: 'assets/shopify-integration/ThumbnailIconicTemplate.png',
    thumbnailIconicTemplate224: 'assets/shopify-integration/ThumbnailIconicTemplate224.png',
    thumbnailPrimeTemplate: 'assets/shopify-integration/ThumbnailPrimeTemplate.png',
    thumbnailPrimeTemplate224: 'assets/shopify-integration/ThumbnailPrimeTemplate224.png',
    thumbnailSummerTemplate: 'assets/shopify-integration/ThumbnailSummerTemplate.png',
    thumbnailSummerTemplate224: 'assets/shopify-integration/ThumbnailSummerTemplate224.png',
    thumbnailMovementTemplate: 'assets/shopify-integration/ThumbnailMovementTemplate.png',
    thumbnailMovementTemplate224: 'assets/shopify-integration/ThumbnailMovementTemplate224.png',
    thumbnailWaveTechTemplate: 'assets/shopify-integration/ThumbnailWaveTechTemplate.png',
    thumbnailWaveTechTemplate224: 'assets/shopify-integration/ThumbnailWaveTechTemplate224.png',
    thumbnailEleganceTemplate: 'assets/shopify-integration/ThumbnailEleganceTemplate.png',
    thumbnailEleganceTemplate224: 'assets/shopify-integration/ThumbnailEleganceTemplate224.png',
    thumbnailEpicTemplate: 'assets/shopify-integration/ThumbnailEpicTemplate.png',
    thumbnailEpicTemplate224: 'assets/shopify-integration/ThumbnailEpicTemplate224.png',
    thumbnailFamousTemplate: 'assets/shopify-integration/ThumbnailFamousTemplate.png',
    thumbnailFamousTemplate224: 'assets/shopify-integration/ThumbnailFamousTemplate224.png',
    thumbnailBoundlessTemplate: 'assets/shopify-integration/ThumbnailBoundlessTemplate.png',
    thumbnailBoundlessTemplate224: 'assets/shopify-integration/ThumbnailBoundlessTemplate224.png',
    thumbnailVistaTemplate: 'assets/shopify-integration/ThumbnailVistaTemplate.png',
    thumbnailVistaTemplate224: 'assets/shopify-integration/ThumbnailVistaTemplate224.png',
    thumbnailTimelessTemplate: 'assets/shopify-integration/ThumbnailTimelessTemplate.png',
    thumbnailTimelessTemplate224: 'assets/shopify-integration/ThumbnailTimelessTemplate224.png',
    thumbnailFlavorTemplate: 'assets/shopify-integration/ThumbnailFlavorTemplate.png',
    thumbnailFlavorTemplate224: 'assets/shopify-integration/ThumbnailFlavorTemplate224.png',
    thumbnailBlushTemplate: 'assets/shopify-integration/ThumbnailBlushTemplate.png',
    thumbnailBlushTemplate224: 'assets/shopify-integration/ThumbnailBlushTemplate224.png',
    thumbnailSimplifyTemplate: 'assets/shopify-integration/ThumbnailSimplifyTemplate.png',
    thumbnailSimplifyTemplate224: 'assets/shopify-integration/ThumbnailSimplifyTemplate224.png',
    thumbnailHorizonTemplate: 'assets/shopify-integration/ThumbnailHorizonTemplate.png',
    thumbnailHorizonTemplate224: 'assets/shopify-integration/ThumbnailHorizonTemplate224.png',
    emptyTemplate: 'assets/shopify-integration/empty-template.png',
    rocket: 'assets/shopify-integration/rocket.png',
    collectionFeature: 'assets/shopify-integration/collection-filters-feature.png',
    searchWithFilterFeature: 'assets/shopify-integration/search-page-with-filters-feature.png',
    iswFeature: 'assets/shopify-integration/isw-feature.png',
    selectThemeWidgetFeatureGif: 'assets/onboarding/select-theme-step-2.gif',
    warningBoard: 'assets/shopify-integration/warning-board.svg'
  },
  shopifyIntegrationSettings: {
    aiBadge: 'assets/shopify-integration-settings/AI-badge.svg',
    bgHeader: 'assets/shopify-integration-settings/bg-header.png',
    breadcrumbs: 'assets/shopify-integration-settings/breadcrumbs.svg',
    brushSmartStylingAi: 'assets/shopify-integration-settings/brush-smart-styling-AI.svg',
    brush: 'assets/shopify-integration-settings/brush.svg',
    btnCapsule: 'assets/shopify-integration-settings/btn-capsule.svg',
    btnRectangle: 'assets/shopify-integration-settings/btn-rectangle.svg',
    btnRoundedRectangle: 'assets/shopify-integration-settings/btn-rounded-rectangle.svg',
    buyBtn: 'assets/shopify-integration-settings/buy-btn.svg',
    capsule: 'assets/shopify-integration-settings/capsule.svg',
    cart: 'assets/shopify-integration-settings/cart.svg',
    cashDollar: 'assets/shopify-integration-settings/cash-dollar.svg',
    check: 'assets/shopify-integration-settings/check.svg',
    circle: 'assets/shopify-integration-settings/circle.svg',
    color: 'assets/shopify-integration-settings/color.svg',
    colorsMinor: 'assets/shopify-integration-settings/colors-minor.svg',
    database: 'assets/shopify-integration-settings/database.svg',
    discounts: 'assets/shopify-integration-settings/discounts.svg',
    drop: 'assets/shopify-integration-settings/drop.svg',
    editFile: 'assets/shopify-integration-settings/edit-file.png',
    externalLink: 'assets/shopify-integration-settings/external-link.svg',
    eye: 'assets/shopify-integration-settings/eye.svg',
    folder: 'assets/shopify-integration-settings/folder.svg',
    hDots: 'assets/shopify-integration-settings/h-dots.svg',
    header: 'assets/shopify-integration-settings/header.svg',
    infoWarning: 'assets/shopify-integration-settings/info-warning.svg',
    info: 'assets/shopify-integration-settings/info.svg',
    layout1Option: 'assets/shopify-integration-settings/layout-1-option.png',
    layout1: 'assets/shopify-integration-settings/layout-1.png',
    layout2Option: 'assets/shopify-integration-settings/layout-2-option.png',
    layout2: 'assets/shopify-integration-settings/layout-2.png',
    layout4Option: 'assets/shopify-integration-settings/layout-4-option.png',
    layout4: 'assets/shopify-integration-settings/layout-4.png',
    layout5Option: 'assets/shopify-integration-settings/layout-5-option.png',
    layout5: 'assets/shopify-integration-settings/layout-5.png',
    layout6Option: 'assets/shopify-integration-settings/layout-6-option.png',
    layout6: 'assets/shopify-integration-settings/layout-6.png',
    layout7Option: 'assets/shopify-integration-settings/layout-7-option.png',
    layout7: 'assets/shopify-integration-settings/layout-7.png',
    layout8Option: 'assets/shopify-integration-settings/layout-8-option.png',
    layout8: 'assets/shopify-integration-settings/layout-8.png',
    layout82Option: 'assets/shopify-integration-settings/layout-8-2-option.png',
    layout82: 'assets/shopify-integration-settings/layout-8-2.png',
    layoutBulkOptionLocked: 'assets/shopify-integration-settings/layout-bulk-option-locked.png',
    layoutBulkOption: 'assets/shopify-integration-settings/layout-bulk-option.png',
    layoutBulk: 'assets/shopify-integration-settings/layout-bulk.png',
    package: 'assets/shopify-integration-settings/package.svg',
    premiumBadge: 'assets/shopify-integration-settings/premium-badge.png',
    questionMark: 'assets/shopify-integration-settings/question-mark.svg',
    rectangle: 'assets/shopify-integration-settings/rectangle.svg',
    roundedRectangle: 'assets/shopify-integration-settings/rounded-rectangle.svg',
    roundedSquare: 'assets/shopify-integration-settings/rounded-square.svg',
    section: 'assets/shopify-integration-settings/section.svg',
    sidebar: 'assets/shopify-integration-settings/sidebar.svg',
    square: 'assets/shopify-integration-settings/square.svg',
    themes: 'assets/shopify-integration-settings/themes.svg',
    typography: 'assets/shopify-integration-settings/typography.svg',
    waving: 'assets/shopify-integration-settings/waving.svg'
  },
  standardSearch: {
    badgeAi: 'assets/standard-search/badge-ai.png',
    clock: 'assets/standard-search/clock.png',
    guideTourStep2: 'assets/standard-search/guide-tour-step-2.gif',
    guideTourStep3: 'assets/standard-search/guide-tour-step-3.gif',
    guideTourStep4: 'assets/standard-search/guide-tour-step-4.gif',
    guideTourStep5: 'assets/standard-search/guide-tour-step-5.gif',
    guideTourStep6: 'assets/standard-search/guide-tour-step-6.gif',
    guideTourStep7: 'assets/standard-search/guide-tour-step-7.gif',
    guideTourStep8: 'assets/standard-search/guide-tour-step-8.gif',
    notesMinor: 'assets/standard-search/notes_minor.svg',
    wand: 'assets/standard-search/wand.svg',
    welcome: 'assets/standard-search/welcome.png'
  },
  styles: {
    bold: 'assets/styles/bold.svg',
    colorWheel: 'assets/styles/colorWheel.png',
    italic: 'assets/styles/italic.svg',
    noColor: 'assets/styles/noColor.png',
    underline: 'assets/styles/underline.svg'
  },
  subscription: {
    '5StarReviews': 'assets/subscription/5-star-reviews.svg',
    analytics: 'assets/subscription/analytics.svg',
    customer: 'assets/subscription/customer.svg',
    dieselGray: 'assets/subscription/diesel-gray.png',
    durexGray: 'assets/subscription/durex-gray.png',
    filter: 'assets/subscription/filter.svg',
    gapGray: 'assets/subscription/gap-gray.png',
    lacosteGray: 'assets/subscription/lacoste-gray.png',
    liveChat: 'assets/subscription/live-chat.svg',
    maviGray: 'assets/subscription/mavi-gray.png',
    moneyBack: 'assets/subscription/money-back.svg',
    rating: 'assets/subscription/rating.svg',
    schollGray: 'assets/subscription/scholl-gray.png',
    search: 'assets/subscription/search.svg',
    shopifyPlus: 'assets/subscription/shopify-plus.svg',
    star: 'assets/subscription/star.svg',
    sync: 'assets/subscription/sync.svg'
  },
  subscriptionV3: {
    addon: {
      aiIcon: 'assets/subscription-v3/addon/ai-icon.png',
      aiPowerRecommendationBanner:
        'assets/subscription-v3/addon/ai-power-recommendation-banner.png',
      aiPowerSearchBanner: 'assets/subscription-v3/addon/ai-power-search-banner.png',
      analyticsBanner: 'assets/subscription-v3/addon/analytics-banner.png',
      autocompleteIcon: 'assets/subscription-v3/addon/autocomplete-icon.png',
      calenderIcon: 'assets/subscription-v3/addon/calender-icon.png',
      clockIcon: 'assets/subscription-v3/addon/clock-icon.png',
      comparisonIcon: 'assets/subscription-v3/addon/comparison-icon.png',
      download: 'assets/subscription-v3/addon/download.svg',
      dynamicRule: 'assets/subscription-v3/addon/dynamic-rule.png',
      easySetup: 'assets/subscription-v3/addon/easy-setup.png',
      enhanceIcon: 'assets/subscription-v3/addon/enhance-icon.png',
      exportIcon: 'assets/subscription-v3/addon/export-icon.png',
      intelligenceIcon: 'assets/subscription-v3/addon/intelligence-icon.png',
      merchandisingIcon: 'assets/subscription-v3/addon/merchandising-icon.png',
      note: 'assets/subscription-v3/addon/note.svg',
      placement: 'assets/subscription-v3/addon/placement.png',
      priorityIcon: 'assets/subscription-v3/addon/priority-icon.png',
      quickIcon: 'assets/subscription-v3/addon/quick-icon.png',
      quickSetupIcon: 'assets/subscription-v3/addon/quick-setup-icon.png',
      saleIcon: 'assets/subscription-v3/addon/sale-icon.png',
      saveIcon: 'assets/subscription-v3/addon/save-icon.png',
      slide: {
        itemSliBannerDes: 'assets/subscription-v3/addon/slide/item_sli_banner_des.png',
        itemSliBoostDes: 'assets/subscription-v3/addon/slide/item_sli_boost_des.png',
        itemSliDemoteDes: 'assets/subscription-v3/addon/slide/item_sli_demote_des.png',
        itemSliExtendDes: 'assets/subscription-v3/addon/slide/item_sli_extend_des.png',
        itemSliFilterDes: 'assets/subscription-v3/addon/slide/item_sli_filter_des.png',
        itemSliFreqDes: 'assets/subscription-v3/addon/slide/item_sli_freq_des.png',
        itemSliHideDes: 'assets/subscription-v3/addon/slide/item_sli_hide_des.png',
        itemSliIncreaseDes: 'assets/subscription-v3/addon/slide/item_sli_increase_des.png',
        itemSliInsightDes: 'assets/subscription-v3/addon/slide/item_sli_insight_des.png',
        itemSliOptimizeDes: 'assets/subscription-v3/addon/slide/item_sli_optimize_des.png',
        itemSliPinDes: 'assets/subscription-v3/addon/slide/item_sli_pin_des.png',
        itemSliProductDes: 'assets/subscription-v3/addon/slide/item_sli_product_des.png',
        itemSliRecentDes: 'assets/subscription-v3/addon/slide/item_sli_recent_des.png',
        itemSliRelatedDes: 'assets/subscription-v3/addon/slide/item_sli_related_des.png',
        itemSliSemanticDes: 'assets/subscription-v3/addon/slide/item_sli_semantic_des.png',
        itemSliSuggestDes: 'assets/subscription-v3/addon/slide/item_sli_suggest_des.png',
        itemSliSynonymDes: 'assets/subscription-v3/addon/slide/item_sli_synonym_des.png',
        itemSliTrendDes: 'assets/subscription-v3/addon/slide/item_sli_trend_des.png'
      },
      star: 'assets/subscription-v3/addon/star.svg',
      syncFrequencyBanner: 'assets/subscription-v3/addon/sync-frequency-banner.png',
      themeCompatible: 'assets/subscription-v3/addon/theme-compatible.png',
      variantDisplayBanner: 'assets/subscription-v3/addon/variant-display-banner.png',
      variantIcon: 'assets/subscription-v3/addon/variant-icon.png',
      visualMerchandisingBanner: 'assets/subscription-v3/addon/visual-merchandising-banner.png'
    },
    aiPowerSearch: 'assets/subscription-v3/ai-power-search.png',
    alphalete: 'assets/subscription-v3/alphalete.png',
    analytics: 'assets/subscription-v3/analytics.png',
    audistore: 'assets/subscription-v3/audistore.png',
    bbc: 'assets/subscription-v3/bbc.png',
    crocs: 'assets/subscription-v3/crocs.png',
    enhanceAiSearch: 'assets/subscription-v3/enhance-ai-search.png',
    ford: 'assets/subscription-v3/ford.png',
    gap: 'assets/subscription-v3/gap.png',
    guess: 'assets/subscription-v3/guess.png',
    hand: 'assets/subscription-v3/hand.svg',
    lacoste: 'assets/subscription-v3/lacoste.png',
    mavi: 'assets/subscription-v3/mavi.png',
    readTimeMinor: 'assets/subscription-v3/read-time_minor.png',
    recommendation: 'assets/subscription-v3/recommendation.png',
    rising: 'assets/subscription-v3/rising.svg',
    rocket: 'assets/subscription-v3/rocket.png',
    sony: 'assets/subscription-v3/sony.png',
    subscriptionBg: 'assets/subscription-v3/subscription-bg.png',
    syncFrequency: 'assets/subscription-v3/sync-frequency.png',
    tupperware: 'assets/subscription-v3/tupperware.png',
    variantDisplay: 'assets/subscription-v3/variant-display.png',
    visualMerchandising: 'assets/subscription-v3/visual-merchandising.png'
  },
  subscriptionV4: {
    enterpriseBanner: 'assets/subscription-v4/enterprise-banner.png',
    smartStylingBanner: 'assets/subscription-v4/smart-styling-banner-img.png',
    no: 'assets/subscription-v4/no.svg',
    starReview: 'assets/subscription-v4/star-review.svg',
    star: 'assets/subscription-v4/star.svg',
    tick: 'assets/subscription-v4/tick.svg',
    yes: 'assets/subscription-v4/yes.svg'
  },
  subscriptionV5: {
    trialStatusBg: 'assets/subscription-v5/trial-status-bg.png',
    subscribedStatusBg: 'assets/subscription-v5/subscribed-status-bg.png',
    expiredStatusBg: 'assets/subscription-v5/expired-status-bg.png',
    priceListFilledIcon: 'assets/subscription-v5/price-list-filled.png',
    filledPlanIcon: 'assets/subscription-v5/plan-filled.png',
    discountIcon: 'assets/subscription-v5/discounts-minor.png',
    markPaidIcon: 'assets/subscription-v5/mark-paid_minor.png',
    enterprisePackage: 'assets/subscription-v5/enterprise-package.png',
    enterpriseImg: 'assets/subscription-v5/enterprise-img.png',
    enterpriseTrial: 'assets/subscription-v5/enterprise-trial-v5.png',
    videoGuideThumbnail: 'assets/subscription-v5/banner-guide.png'
  },
  sync: {
    delete: 'assets/sync/delete.svg',
    error: 'assets/sync/error.svg',
    success: 'assets/sync/success.svg',
    SuccessIcon: 'assets/sync/success.svg'
  },
  themeSetting: {
    appMajor: 'assets/theme-setting/app-major.svg',
    bgHalfSample: 'assets/theme-setting/bg-half-sample.png',
    bgSample: 'assets/theme-setting/bg-sample.png',
    delete: 'assets/theme-setting/delete.svg',
    fullscreen: 'assets/theme-setting/fullscreen.svg',
    sample: 'assets/theme-setting/sample.svg',
    view: 'assets/theme-setting/view.svg'
  },
  thirdPartyIntegration: {
    clock: 'assets/third-party-integration/clock.svg',
    bannerBackgroundBoostReviewsio:
      'assets/third-party-integration/Banner background - Boost x Reviewsio.png'
  },
  variantDisplay: {
    lockFeature01: 'assets/variant-display/lock-feature-01.png',
    lockFeature02: 'assets/variant-display/lock-feature-02.png',
    lockFeature03: 'assets/variant-display/lock-feature-03.png'
  },
  appInsight: {
    up: {
      IconUp1: 'assets/app-insight/up/up1.svg',
      IconUp2: 'assets/app-insight/up/up2.svg',
      IconUp3: 'assets/app-insight/up/up3.svg',
      IconUp4: 'assets/app-insight/up/up4.svg',
      IconUp5: 'assets/app-insight/up/up5.svg',
      IconUp6: 'assets/app-insight/up/up6.svg',
      IconUp7: 'assets/app-insight/up/up7.svg',
      IconUp8: 'assets/app-insight/up/up8.svg',
      IconUp9: 'assets/app-insight/up/up9.svg',
      IconUp10: 'assets/app-insight/up/up10.svg'
    },
    down: {
      IconDown1: 'assets/app-insight/down/down1.svg',
      IconDown2: 'assets/app-insight/down/down2.svg',
      IconDown3: 'assets/app-insight/down/down3.svg',
      IconDown4: 'assets/app-insight/down/down4.svg',
      IconDown5: 'assets/app-insight/down/down5.svg',
      IconDown6: 'assets/app-insight/down/down6.svg',
      IconDown7: 'assets/app-insight/down/down7.svg',
      IconDown8: 'assets/app-insight/down/down8.svg',
      IconDown9: 'assets/app-insight/down/down9.svg',
      IconDown10: 'assets/app-insight/down/down10.svg'
    }
  },
  b2b: {
    wholesaleSellingGuide: 'assets/b2b/wholesale-selling-guide-img.svg',
    globalSellingGuide: 'assets/b2b/global-selling-guide-img.svg'
  },
  generalSwatch: {
    thumbnail: 'assets/general-swatch/general-swatch-work.png'
  },
  countdown: {
    lock: 'assets/countdown/lock.png',
    lockPlan: 'assets/countdown/lock-plan.png',
    topBottom: 'assets/countdown/top-bottom.png',
    inline: 'assets/countdown/inline.png',
    floating: 'assets/countdown/floating-bar.png',
    step1: 'assets/countdown/step-1.png',
    step23: 'assets/countdown/step-23.png',
    step4: 'assets/countdown/step-4.png'
  },
  postPurchase: {
    thumbnail: 'assets/post-purchase/post-purchase-thumbnail.png',
    circleCheck: 'assets/post-purchase/circle-check-blue.svg',
    unlockThumbnail: 'assets/post-purchase/post-purchase-unlock.png'
  }
};
